import { Theme } from '@mui/material/styles';

export const getMuiTextField = (theme: Theme): Record<string, unknown> => ({
  MuiTextField: {
    styleOverrides: {
      root: {
        '& input, & textarea': {
          backgroundColor: 'transparent',
          color: theme.palette.text.primary,
        },
        '& input[type=number]': {
          mozAppearance: 'textfield',
        },
        '& input[type=number]::-webkit-outer-spin-button': {
          webkitAppearance: 'none',
          margin: 0,
        },
        '& input[type=number]::-webkit-inner-spin-button': {
          webkitAppearance: 'none',
          margin: 0,
        },
      },
    },
  },
});
